import { computed, ComputedRef } from 'vue'

import { HistoryPageStateViewModel } from '@/presentation/viewmodels/history/historyPageStateViewModel'

export class HistoryPageStatePresenter {
  private viewModel: HistoryPageStateViewModel

  constructor(viewModel: HistoryPageStateViewModel) {
    this.viewModel = viewModel
  }

  get historyExpandedList(): ComputedRef<{ [judgeId: number]: boolean }> {
    return this.viewModel.historyExpandedList
  }

  get historyLoadingList(): ComputedRef<{ [judgeId: number]: boolean }> {
    return this.viewModel.historyLoadingList
  }

  hasDataInExpandedList(judgeId: number): ComputedRef<boolean> {
    return computed(() => judgeId in this.viewModel.historyExpandedList.value)
  }

  hasDataInLoadingList(judgeId: number): ComputedRef<boolean> {
    return computed(() => judgeId in this.viewModel.historyLoadingList.value)
  }

  get pageIndex(): ComputedRef<number> {
    return this.viewModel.pageIndex
  }

  get isFirstOpendPage(): ComputedRef<boolean> {
    return this.viewModel.isFirstOpendPage
  }

  get isNotMoreHistoryList(): ComputedRef<boolean> {
    return this.viewModel.isNotMoreHistoryList
  }

  setPageIndex(pageIndex: number): void {
    this.viewModel.setPageIndex(pageIndex)
  }

  setIsFirstOpendPage(flag: boolean): void {
    this.viewModel.setIsFirstOpendPage(flag)
  }
}
